namespace Matrix.Data {
    export interface EntityLinkForm {
        EntityName: Serenity.LookupEditor;
        Caption: Serenity.StringEditor;
        Url: UrlEditor;
        Target: UrlTargetEditor;
        Icon: IconClassEditor;
        IconColor: ColorPicker;
        DisplayOrder: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class EntityLinkForm extends Serenity.PrefixedContext {
        static formKey = 'Data.EntityLink';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!EntityLinkForm.init)  {
                EntityLinkForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = UrlEditor;
                var w3 = UrlTargetEditor;
                var w4 = IconClassEditor;
                var w5 = ColorPicker;
                var w6 = s.IntegerEditor;
                var w7 = StaticTextBlock;
                var w8 = ReadOnlyDateTime;

                Q.initFormType(EntityLinkForm, [
                    'EntityName', w0,
                    'Caption', w1,
                    'Url', w2,
                    'Target', w3,
                    'Icon', w4,
                    'IconColor', w5,
                    'DisplayOrder', w6,
                    'CreatedBy', w7,
                    'CreatedWhen', w8,
                    'UpdatedBy', w7,
                    'UpdatedWhen', w8,
                    'Version', w7
                ]);
            }
        }
    }
}
